import { defineComponent as _defineComponent } from 'vue'

export enum OzPlainButtonColorScheme {
  Bare = 'Bare',
  Primary = 'Primary',
  Secondary = 'Secondary',
  SecondaryIcon = 'SecondaryIcon',
  TertiaryIcon = 'TertiaryIcon',
  Active = 'Active',
  SecondaryIconInverse = 'SecondaryIconInverse',
}

export enum OzPlainButtonSizePreset {
  Bare = 'Bare',
  H44px = 'H44px',
  H40px = 'H40px',
  H32px = 'H32px',
  H28px = 'H28px',
  H24px = 'H24px',
}

export { OzBaseButtonHrefMode as OzPlainButtonHrefMode } from '@@/library/v4/components/OzBaseButton.vue'
const __default__ = {}

import OzBaseButton, { OzBaseButtonHrefMode } from '@@/library/v4/components/OzBaseButton.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzPlainButton',
  props: {
    darkMode: { type: [Boolean, String], default: 'auto' },
    disabled: { type: Boolean, default: false },
    href: { default: undefined },
    hrefTarget: { default: undefined },
    hrefMode: { default: OzBaseButtonHrefMode.Default },
    colorScheme: { default: OzPlainButtonColorScheme.Primary },
    sizePreset: { default: OzPlainButtonSizePreset.H44px },
    shouldTruncateText: { type: Boolean, default: true },
    autoHeight: { type: Boolean, default: false },
    text: { default: undefined },
    title: { default: undefined },
    iconLeft: { type: Boolean, default: false }
  },
  emits: ["mouseenter", "mouseleave", "mousedown", "keydown", "click", "focus", "blur", "touchstart"],
  setup(__props: any) {

/**
 * @file Background-less button.
 */




return { __sfc: true,OzPlainButtonColorScheme, OzPlainButtonSizePreset, OzBaseButton }
}

})